import React, { Fragment, useState } from "react";
import AntDrawer from "./AntDrawer";
import { Button, Icon } from "antd";

function AddButton({ body, profile }){
    let [ visible, setVisible ] = useState(false);

    function showDrawer(body){
        setVisible(visible = true);
    }
   
    return(
        <Fragment>
            <AntDrawer 
                visible={visible} 
                setVisible={setVisible} 
                drawerBody={body} 
                profile={profile}
            />
            <Button 
                shape="circle" 
                style={{ color: "green", backgroundColor: "#F5F5F5", marginLeft: 15 }}
                onClick={() => showDrawer(body)}
            >
                <Icon type="plus" style={{paddingBottom: 5}}/>
            </Button>
        </Fragment>
    )
}

export default AddButton;


// WEBPACK FOOTER //
// ./src/components/common/AddButton.jsx